import { theme, SxProperties } from '@bvi/mui-theme';

export const styles = {
  headerCell: {
    color: theme.palette.grey[300],
    fontWeight: '300',
    fontSize: '16px',
    backgroundColor: 'transparent',
    minWidth: '120px',
    verticalAlign: 'bottom',
  },
  valueCell: {
    fontFamily: 'Lato',
    fontWeight: '700',
    padding: 2,
    textAlign: 'center',
    paddingTop: '11px',
    verticalAlign: 'baseline',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleSkeleton: {
    minWidth: '100px',
  },
  stickyWrapper: {
    position: 'sticky',
    top: '0',
    backgroundColor: 'white',
    borderRadius: '10px',
    zIndex: 5,
  },
  headerCellContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  headerCellLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    textAlign: 'center',
  },
  headerCellTooltip: {
    marginTop: '8px',
  },
  headerTitle: {
    fontSize: '20px',
  },
  legend: {
    marginTop: 1,
    color: theme.palette.grey[400],
    fontSize: '18px',
    lineHeight: 1.4,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    alignItems: 'center',
    width: '100%',
    columnGap: 2,
    rowGap: 1,
  },
  /** Each line is centered within its third of the legend row. */
  legendItemCell: {
    justifySelf: 'center',
    textAlign: 'center',
    maxWidth: '100%',
  },
} satisfies SxProperties;
